import mapboxgl from 'mapbox-gl';
import moment from 'moment';

import { PaginationRequestParams } from '~globals/types';
import { RouteStateTypes } from '~globals/types/enums';
import { ApiTransactionRouteItem } from '~services/apiTransaction/types';
import { RouteFilter } from '~services/route/types';
import { formatterDate } from '~utils/formatter';

const getRouteItemCoords = (
  routeItem: ApiTransactionRouteItem,
): mapboxgl.LngLat => {
  const longitude = (routeItem.warehouse?.longitude ??
    routeItem.item?.longitude) as number;
  const latitude = (routeItem.warehouse?.latitude ??
    routeItem.item?.latitude) as number;

  return new mapboxgl.LngLat(longitude, latitude);
};

export const getRouteTripCoords = (
  routeItems: ApiTransactionRouteItem[],
): number[][] => {
  const coords: number[][] = [];

  for (let indexStep = 0; indexStep < routeItems.length - 1; indexStep++) {
    const startItemTrip = getRouteItemCoords(routeItems[indexStep]);
    const endItemTrip = getRouteItemCoords(routeItems[indexStep + 1]);

    coords.push(startItemTrip.toArray());
    coords.push(endItemTrip.toArray());
  }

  return coords;
};

export const getDefaultPayloadFetchRoutes = (
  routeStateTypesId: RouteStateTypes[],
): PaginationRequestParams<RouteFilter<true>> => {
  const fromDate = new Date(
    moment().subtract(3, 'days').startOf('day').format(),
  );

  const toDate = new Date(moment().add(3, 'days').endOf('day').format());

  return {
    pagination: { page: 1, sizePerPage: -1 },
    filters: {
      dateFrom: formatterDate(fromDate, {
        format: moment.HTML5_FMT.DATETIME_LOCAL_MS,
      }),
      dateTo: formatterDate(toDate, {
        format: moment.HTML5_FMT.DATETIME_LOCAL_MS,
      }),
      routeStateTypesId,
      includeApiTransaction: true,
      routeCode: null,
      driversId: null,
      vehiclesId: null,
    },
  };
};
